/* eslint-disable @typescript-eslint/no-explicit-any */
import { createFileRoute } from '@tanstack/react-router'
import QuestionCollection from '@/features/question-lib/question-collection'

export const Route = createFileRoute(
  '/_authenticated/question-lib/$quesiontionLibId'
)({
  component: QuestionsLibWrapper,
})

function QuestionsLibWrapper() {
  const { quesiontionLibId } = Route.useParams() as {
    quesiontionLibId: string
  }
  return <QuestionCollection key={quesiontionLibId} />
}
